import React from 'react';
import Button from '@mui/material/Button';

import { useClientContext } from '@lib/useClientContext';
import { trySession } from '@lib/Session';
import { useSnackbar } from '@lib/useSnackbar';

import { TelegramBotName } from '../../../const';
import { cnApp } from '../App.const';

function useListener() {
    const [leftAttempts, setLeftAttempts] = React.useState<number | undefined>(undefined);
    const { uuid, setSession } = useClientContext();
    const { show } = useSnackbar();
    const logInURL = `https://t.me/${TelegramBotName}?start=auth_${uuid}`;

    const onClick = React.useCallback(() => {
        setLeftAttempts(2);
    }, []);

    React.useEffect(() => {
        const attempt = leftAttempts;

        if (attempt === undefined) {
            return;
        }

        const onVisibilityChanged = () => {
            if (document.hidden) return;

            trySession().then(result => {
                setSession(result.uuid, result.user, result.apiRequest);

                if (result.user) {
                    show({
                        text: `Hello, ${result.user.name.trim()}!`,
                        duration: 3000,
                        horizontal: 'center',
                        vertical: 'bottom',
                    });
                }
            });

            const nextValue = attempt - 1;

            setLeftAttempts(nextValue > 0 ? nextValue : undefined);
        };

        window.addEventListener('visibilitychange', onVisibilityChanged);

        return () => {
            window.removeEventListener('visibilitychange', onVisibilityChanged);
        };
    }, [leftAttempts]);

    return { onClick, logInURL };
}

export const AppLoginButton: React.FC = () => {
    const { onClick, logInURL } = useListener();

    return (
        <Button
            className={cnApp('LoginButton')}
            color="inherit"
            href={logInURL}
            target="_blank"
            onClick={onClick}
        >
            Login
        </Button>
    );
};
